import { Shop } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import heroAbout from '../assets/hero-about.jpg';

function About() {
  return (
    <Box sx={{ padding: 4, backgroundColor: '#f5f5f5' }}>
      <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ marginBottom: 4 }}>
        About KBros Leather
      </Typography>

      <Box sx={{ maxWidth: '800px', margin: '0 auto' }}>
        <Box
          component="img"
          src={heroAbout}
          alt="Hand-stitching a leather wallet at the KBros workbench"
          sx={{
            width: '100%',
            height: { xs: 220, sm: 320, md: 400 },
            objectFit: 'cover',
            borderRadius: 2,
            display: 'block',
          }}
        />
      </Box>

      {/* Content Section */}
      <Box sx={{ padding: { xs: 3, md: 6 }, maxWidth: '800px', margin: '0 auto', lineHeight: 1.8 }}>
        <Typography variant="h4" sx={{ mb: 3 }}>
          The Story Behind KBros Leather
        </Typography>
        <Typography variant="body1" paragraph>
          KBros Leather began as a shared dream between two brothers, Jeremy and A.J. Keiper. From
          a young age, they were captivated by the timeless beauty and resilience of leather. What
          started as a hobby in their small garage has now grown into a thriving business known for
          its dedication to quality craftsmanship and attention to detail.
        </Typography>
        <Typography variant="body1" paragraph>
          Every product tells a story. The brothers believe that the items we carry every day—
          whether a wallet, keychain, or journal—should reflect our personality and values. With this
          belief in mind, they have poured their heart and soul into creating leather goods that are
          not just functional but also meaningful.
        </Typography>

        <Typography variant="h4" sx={{ mt: 6, mb: 3 }}>
          A Commitment to Craftsmanship
        </Typography>
        <Typography variant="body1" paragraph>
          At KBros Leather, every piece is handcrafted using traditional methods combined with
          modern techniques. From selecting the finest eco-tanned leather to the final stitch, each
          step in the process is executed with precision and care. The result is a product that is
          not only durable but also beautifully unique.
        </Typography>
        <Typography variant="body1" paragraph>
          The brothers take pride in their ability to customize each piece, ensuring that every
          customer receives something truly special. Whether it’s a gift for a loved one or a treat
          for yourself, KBros Leather products are designed to stand the test of time.
        </Typography>

        <Typography variant="h4" sx={{ mt: 6, mb: 3 }}>
          Looking Ahead
        </Typography>
        <Typography variant="body1" paragraph>
          As the business continues to grow, Jeremy and A.J. remain grounded in their mission: to
          create leather goods that connect people to the art of craftsmanship. They are constantly
          exploring new designs and techniques, always looking for ways to improve and innovate.
        </Typography>
        <Typography variant="body1" paragraph>
          Thank you for being part of the KBros Leather journey. Every product is a testament to
          their passion for creating timeless pieces, and they look forward to sharing many more
          stories with you.
        </Typography>

        {/* Call to Action */}
        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Button variant="contained" color="primary" href="https://kbrosleather.etsy.com" target="_blank" rel="noopener noreferrer" startIcon={<Shop />}>
            Explore Our Collection
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default About;
